<template>
    <!-- 增加备注 -->
    <el-dialog
            width="45%"
            @closed="closed"
            :visible.sync="show"
            title="新增备注">

        <el-form label-width="90px" ref="addForm" :rules="rules" :model="formData">
            <el-form-item prop="content" label="内容:" size="mini">
                <el-input
                        type="textarea"
                        placeholder="请输入备注内容"
                        maxlength="128"
                        :autosize="{ minRows: 3, maxRows: 6}"
                        v-model="formData.content"
                        show-word-limit
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button :loading="addLoading" @click="addClick" type="primary" size="mini">确 定</el-button>
            <el-button size="mini" @click="show = false">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {mapState,mapMutations} from 'vuex'

    export default {
        name: "AddProRemark",
        data() {
            return {
                show: false,
                addLoading:false,

                formData:{
                    produce_requirement:'',
                    content:'',
                },

                rules: {
                    content: [
                        {required: true, message: '请输入备注内容', trigger: 'blur'},
                        {min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: 'blur'}
                    ],
                },
                currentProRequirement:null,
            }
        },
        computed:{
            addFormComponent(){
                return this.$refs.addForm
            },
            ...mapState(['currentUserInfo'])
        },
        methods:{
            /**
             * 确定添加备注
             */
            addClick(){
                this.addFormComponent.validate(validateResult=>{
                    if(validateResult){ // 验证通过
                        this._sendAddRequest()
                    }
                })
            },

            /**
             * 发送新增(备注)请求
             */
            _sendAddRequest(){
                this.addLoading=true
                const url = '/order_platform/api/pr_remarks/'
                const data = this.formData
                data['created_username'] = this.currentUserInfo.username
                this.$postRequest(url,data)
                    .then(response=>{
                        this.addLoading=false
                        this.currentProRequirement.prremark_set.push(response.data)
                        this.addProRequirements([this.currentProRequirement])
                        this.$message({
                            type:'success',
                            showClose:true,
                            message:'新增备注成功!'
                        })
                        this.show=false

                    })
                    .catch(()=>{
                        this.addLoading=false
                    })

            },

            /**
             * 打开对话框(供父组件调用)
             * @param {Object} proRequirement 产品信息
             */
            open(proRequirement) {
                this.show = true
                this.formData.produce_requirement = proRequirement.id
                this.formData.content = ''
                this.currentProRequirement = proRequirement
            },

            closed(){
                this.addFormComponent.clearValidate()
            },

            ...mapMutations(['addProRequirements'])
        },
    }
</script>

<style scoped>

</style>